import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Popular tag - Get All (Read)
export const GetAll = createAsyncThunk(
  "blogs/getstarted/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Blogs.GetStarted}?image=${filter?.image || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Get (Read)
export const GetSingle = createAsyncThunk(
  "blogs/getstarted/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Blogs.GetStarted}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Popular tag - Create (Add)
export const Create = createAsyncThunk(
  "blogs/getstarted/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Blogs.GetStarted, data);
      return res; // The new tag object
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Update
export const Update = createAsyncThunk(
  "blogs/getstarted/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Blogs.GetStarted}/${id}`, data);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Popular tag - Delete
export const Delete = createAsyncThunk(
  "blogs/getstarted/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Blogs.GetStarted}/${id}`);
      return id; // Return the id of the deleted tag
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Status
export const StatusGetStarted = createAsyncThunk(
  "blogs/getstarted/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Blogs.GetStarted}/${id}`);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "getstarted",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (getstarted) => getstarted.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (getstarted) => getstarted.id !== action.payload.id); // Remove the tag with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusGetStarted.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusGetStarted.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (getstarted) => getstarted.id !== action.payload.id); // Remove the tag with the deleted id
      })
      .addCase(StatusGetStarted.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
